import React from 'react';
import logo from '../TBL Logo White.png';
import './Menu.css';

const Menu = ({ onSelectQuiz, onSelectWinemakers, onBack }) => {
  return (
    <div className="menu">
      <header className="menu-header">
        <button className="back-button" onClick={onBack}>
          ← Back to Home
        </button>
        <img src="/Blendfest Logo.png" className="menu-logo" alt="logo" />
        <h1>WINE BLENDING SEMINAR</h1>
        <p className="menu-description">
          Explore our seminar content
        </p>
      </header>

      <div className="menu-tiles">
        <div className="menu-tile" onClick={onSelectWinemakers}>
          <h2>Meet the Winemakers</h2>
          <p>Learn about our expert winemakers</p>
        </div>

        <div className="menu-tile" onClick={onSelectQuiz}>
          <h2>Take the Quiz</h2>
          <p>Discover your wine preferences</p>
        </div>
      </div>

      <div className="footer">
        <div className="footer-separator"></div>
        <img src={logo} className="footer-logo" alt="TBL Logo" />
      </div>
    </div>
  );
};

export default Menu;
